import React from 'react'
import { connect } from 'react-redux'
import UsersIndex from './UsersIndex'

import { set_path } from '../actions/'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedB2bAccounts extends React.Component {
  componentWillMount() {
    this.props.setPath('b2baccounts') // change depending on component
  }

  render() {
    return <UsersIndex header="B2b Users" userbase="b2b" location={this.props.location}/>
  }
}

const B2bAccounts = connect(mapStateToProps, mapDispatchToProps)(ConnectedB2bAccounts)

export default B2bAccounts



// WEBPACK FOOTER //
// ./src/js/components/B2bAccounts.js